<template>
    <div class="right author-right pt0">
        <chapterTip>
            <div slot="tip-name">{{$lang('authorCenter.stories.contractSign[0]')}}</div>
            <div slot="tip-con">
                {{$lang('authorCenter.stories.completing[0]')}}
            </div>
            <div slot="tip-btn">
                <el-button v-if="finishStatus || finishApply && finishApply.applyStatus == 2" class="f16 font-MT" type="success" size="medium">{{$lang('authorCenter.stories.success')}}</el-button>
                <div class="flexible aItem-center">
<!--                    <el-button v-if="words < 80000" class="f16 font-MT" disabled type="info" size="medium">Submit</el-button>-->
                    <el-button v-if="!finishStatus && !finishApply||finishApply && finishApply.applyStatus == -2" class="f16 font-MT" size="medium" @click="closesure(true)">{{$lang('authorCenter.stories.submit')}}</el-button>
                    <el-popover
                            placement="top"
                            title=""
                            width="280"
                            popper-class="contract-pop"
                            v-if="finishApply && finishApply.applyStatus == -2"
                            trigger="hover"
                            :content="finishApply&&finishApply.comment">
                        <i v-if="finishApply && finishApply.applyStatus == -2" slot="reference" class="el-icon-warning text-danger ml0" style="font-size: 25px;"></i>
                    </el-popover>
                </div>
                <el-button v-if="finishApply&&finishApply.applyStatus == 1" class="f16 font-MT" type="info" size="medium">{{$lang('authorCenter.stories.submitted')}}</el-button>
            </div>
        </chapterTip>
        <surePop v-if="isComplete" @closesure="closesure">
            <div slot="surecon">
                <div class="title flexible aItem-center jc-center f20 text-333 font-MT">
                    {{$lang('authorCenter.stories.infoTips')}}
                </div>
                <div class="surecon-detail f18 text-333 flexible aItem-center jc-center">
                    <div class="text-line36">
                        {{$lang('authorCenter.stories.completing[1]')}}
                    </div>
                </div>
            </div>
            <div slot="optionbox" class="btn-item flexible jc-center">
                <el-button size="medium" class="f16 font-MT" @click="finishbookFun()">{{$lang('authorCenter.stories.confirm')}}</el-button>
                <el-button size="medium" class="el-button-opa f16 font-MT" @click="closesure(false)">{{$lang('authorCenter.stories.cancel')}}</el-button>
            </div>
        </surePop>
    </div>
</template>

<script>
    import { finishbook } from 'apiurl/author';
    export default {
        name: "",
        props: {
            bookdetail: Object
        },
        data () {
            return{
                finishStatus: null,
                finishApply: null,
                isComplete: false,
            }
        },
        watch: {
            bookdetail (n) {
                console.log(this.bookdetail)
                this.finishStatus = this.bookdetail.finished
                this.finishApply = this.bookdetail.finishApply?this.bookdetail.finishApply:null
            },
        },
        mounted() {
            this.finishStatus = this.bookdetail.finished
            this.finishApply = this.bookdetail.finishApply?this.bookdetail.finishApply:null
        },
        methods: {
            finishbookFun() {
                finishbook(this.$route.params.id)
                    .then(res => {
                        if (res.success) {
                            this.closesure()
                            this.$success('custom', res.message)
                            if (!this.finishApply) {
                                this.finishApply = {}
                            }
                            this.$set(this.finishApply,'applyStatus',  1)
                            this.$emit('changeChapter', '')
                        }
                    })
                    .catch(() => {
                    });
            },
            closesure (data) {
                this.isComplete = data
                this.$emit('changePop', data)
            },
        }
    }
</script>

<style lang="scss">
    .contract-pop{
        background: rgba(0,0,0,0.8)!important;
        color: #fff;
        font-size: 16px!important;
        font-family: Arial!important;
        line-height: 26px!important;
        border-radius: 12px!important;
        .popper__arrow,.popper__arrow::after{
            border-top-color: #000!important;
        }

    }
</style>
